import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import VueJwtDecode from 'vue-jwt-decode'

import datatable from './modules/datatable.store'
import filter from './modules/filter.store'
import modalStore from './modules/modal'
import addEdit from './modules/addEdit'
import searchStore from './modules/search'
import editStore from './modules/edit'
import level1 from './modules/level1'
import landingpage from './modules/landingpage'
import modalReqApp from './modules/modalRequestApproval'
import myRequest from './modules/myrequest.store'
import approvalSheet from './modules/approval.store'
import notifStore from './modules/notif.store'
import editingStore from './modules/editing.store'
import tkdnStore from './modules/tkdn'
import vaStore from './modules/dashboard-va'
import kpiStore from './modules/dashboard-kpi'
import monitoringStore from './modules/dashboard-monitoring'

//masterdata
import mdDatabaseStore from './modules/masterdata/database'
import mdMatrixLegalStore from './modules/masterdata/matrix'
import mdLandingStore from './modules/masterdata/landingpage'

import { api } from '../services/config'
import { mixin } from '@/mixins/helper'
import { permissionData } from './general_permission'

Vue.use(Vuex)
const setRoleName = value => {
  switch (value) {
    case 1:
      return 'SIPM'
      break
    case 2:
      return 'HEAD SIPM'
      break
    case 3:
      return 'PROCUREMENT'
      break
    case 4:
      return 'OPERATIONAL COMPLIANCE'
      break
    case 5:
      return 'HEAD OPERATIONAL COMPLIANCE'
      break
    case 6:
      return 'HSE'
      break
    case 7:
      return 'HEAD HSE'
      break
    case 8:
      return 'GENERAL USER'
      break
    case 9:
      return 'DEPT CM'
      break
    case 10:
      return 'DEPT LEGAL'
      break
    case 11:
      return 'REQUESTOR'
      break
    case 12:
      return 'GM SIPM'
      break
    case 13:
      return 'KTT HSE'
      break
    default:
      return 'Not Login'
      break
  }
}

const generateInitial = value => {
  let text = value
  text = value.replace(/[0-9()_-]/gi, ' ')
  let arr = text.split(' ')
  let initial = []

  if (arr.length > 1) {
    return arr.join('-')
  }

  return text
}

export default new Vuex.Store({
  state: {
    globalLoading: false,
    showModalLogin: false,
    showModalReset: false,
    showModalForgot: false,
    showModalNotif: false,
    notifText: '',
    csv_data: null,
    currentUser: null,
    userinit: '0-Not-User-Login',
    currentEmail: null,
    userid: null,
    permissions: null,
    kode: null,
    token: null,
    role_id: null,
    rolename: '0-Not-Login',
    spmDashboardDetail: null,
    spmDashboardSummary: null,
    spmDashboardCompany: null,
    spmDashboardFrom: null,
    spmDashboardTo: null,
    csiDashboardDetail: null,
    csiDashboardSummary: null,
    csiDashboardCompany: null,
    csiDashboardYearFrom: null,
    csiDashboardMonthFrom: null,
    csiDashboardYearTo: null,
    csiDashboardMonthTo: null,
  },

  mutations: {
    SET_CSV_DATA(state, data) {
      state.csv_data = data
    },
    AUTO_LOGIN(state) {
      const isToken = localStorage.getItem('token')
      const isPermissions = JSON.parse(localStorage.getItem('permissions'))
      const isKode = JSON.parse(localStorage.getItem('kode'))
      if (isToken && isPermissions) {
        const dec = VueJwtDecode.decode(isToken)
        state.currentUser = dec.name
        state.currentEmail = dec.email
        state.userid = dec.id
        state.userinit = dec.id + '-' + generateInitial(dec.name)
        state.role_id = isPermissions[0].role_id
        state.rolename =
          isPermissions[0].role_id + '-' + setRoleName(isPermissions[0].role_id)
        state.permissions = isPermissions.reduce(
          (obj, item) => (
            (obj[item.permission_id] = {
              allow: item.allow == 1 ? true : false,
              modul: mixin.methods.$get(item, 'permission.modul'),
              function: mixin.methods.$get(item, 'permission.function'),
            }),
            obj
          ),
          {}
        )
        state.token = isToken
      } else {
        state.permissions = permissionData.reduce(
          (obj, item) => (
            (obj[item.permission_id] = {
              allow: item.allow == 1 ? true : false,
              modul: mixin.methods.$get(item, 'permission.modul'),
              function: mixin.methods.$get(item, 'permission.function'),
            }),
            obj
          ),
          {}
        )
      }

      if (isKode && isKode.length > 0) {
        state.kode = isKode
      }
    },
    UNSET_CURRENT_USER(state) {
      state.currentUser = null
      state.currentEmail = null
      state.userinit = ''
      state.userid = null
      state.role_id = null
      state.rolename = ''
      localStorage.removeItem('token')
      localStorage.removeItem('permissions')
      localStorage.removeItem('kode')
      state.permissions = permissionData.reduce(
        (obj, item) => (
          (obj[item.permission_id] = {
            allow: item.allow == 1 ? true : false,
            modul: mixin.methods.$get(item, 'permission.modul'),
            function: mixin.methods.$get(item, 'permission.function'),
          }),
          obj
        ),
        {}
      )
      state.token = null
    },
    SET_PERMISSIONS(state, permissions) {
      localStorage.setItem('permissions', JSON.stringify(permissions))
      state.permissions = permissions.reduce(
        (obj, item) => (
          (obj[item.permission_id] = {
            allow: item.allow == 1 ? true : false,
            modul: mixin.methods.$get(item, 'permission.modul'),
            function: mixin.methods.$get(item, 'permission.function'),
          }),
          obj
        ),
        {}
      )
    },
    SET_TOKEN(state, token) {
      state.token = token
      localStorage.setItem('token', token)
      const dec = VueJwtDecode.decode(token)
      state.currentEmail = dec.email
      state.currentUser = dec.name
      state.userinit = generateInitial(dec.name)
      state.userid = dec.id
    },
    SET_KODE(state, kode) {
      localStorage.setItem('kode', JSON.stringify(kode))
      state.kode = kode
    },
    SET_LEGALDOC_EDIT(state, value) {
      state.isLegaldocEdit = value
    },
    async GET_PERMISSIONS(state) {
      const { data } = await axios({
        url: `${api}/api/v1/auth/permissions`,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
      })

      state.permissions = {
        access: data.data.access,
        filter: data.data.filter,
      }
    },
    SET_SPM_DASHBOARD(state, data) {
      state.spmDashboardDetail = data.spmDetail
      state.spmDashboardSummary = data.spmSummary
      state.spmDashboardCompany = data.spmCompany
      state.spmDashboardFrom = data.spmFrom
      state.spmDashboardTo = data.spmTo
    },
    SET_CSI_DASHBOARD(state, data) {
      state.csiDashboardDetail = data.csiDetail
      state.csiDashboardSummary = data.csiSummary
      state.csiDashboardCompany = data.csiCompany
      state.csiDashboardYearFrom = data.csiYearFrom
      state.csiDashboardMonthFrom = data.csiMonthFrom
      state.csiDashboardYearTo = data.csiYearTo
      state.csiDashboardMonthTo = data.csiMonthTo
    },
    SET_MODAL_LOGIN(state, status) {
      state.showModalLogin = status
    },
    SET_MODAL_RESET(state, status) {
      state.showModalReset = status
    },
    SET_MODAL_FORGOT(state, status) {
      state.showModalForgot = status
    },
    SET_NOTIF(state, msg) {
      state.showModalNotif = true
      state.notifText = msg

      setTimeout(() => {
        state.showModalNotif = false
        state.notifText = ''
      }, 2000)
    },
    SET_NOTIF_OPEN(state, msg) {
      state.showModalNotif = true
      state.notifText = msg
    },
    SET_NOTIF_CLOSE(state) {
      state.showModalNotif = false
      state.notifText = ''
    },
    DONT_HAVE_PERMISSIONS(state, msg) {
      state.showModalNotif = true
      state.notifText = `Maaf, anda tidak memiliki akses`

      setTimeout(() => {
        state.showModalNotif = false
        state.notifText = ''
      }, 2000)
    },
    SET_GLOBAL_LOADING(state, payload) {
      state.globalLoading = payload
    },
  },
  actions: {
    async login({ dispatch, commit }, params) {
      await commit('SET_CURRENT_USER', params)
      await dispatch('checkLogin')
    },
    logout({ commit }) {
      commit('UNSET_CURRENT_USER')
    },
  },
  modules: {
    datatable,
    filter,
    modalStore,
    addEdit,
    editStore,
    searchStore,
    level1,
    landingpage,
    modalReqApp,
    myRequest,
    approvalSheet,
    notifStore,
    editingStore,
    tkdnStore,
    vaStore,
    kpiStore,
    mdDatabaseStore,
    monitoringStore,
    mdMatrixLegalStore,
    mdLandingStore,
  },
})
